// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"18aaa2ff","455":"c3e4bf6a","977":"9b43ce32"}[chunkId] + ".chunk.js";
};